import { apiRequest } from '@/utils/api-request';
import type { FilestoreReposResponse } from '@/types/filestore';
import { filestoreErrorMessage } from './filestore-request';

export async function listFilestoreRepos(
  orgId: string,
): Promise<FilestoreReposResponse> {
  const response = await apiRequest<FilestoreReposResponse>({
    url: `/v1/orgs/${orgId}/repos`,
    method: 'GET',
    target: 'filestore',
  });

  if (response.detail || !response.data) {
    throw new Error(
      filestoreErrorMessage(response, 'Failed to load file repositories'),
    );
  }
  return response.data;
}
